import React from 'react'
import {
  ATLDivider,
  ATLSpacing,
  ATLTextHead,
  FontWeightEnum,
  SpacingSizesEnum,
  TextAlignmentEnum,
  ATLTextBody,
} from '@appsimples/atlantica-react-native'
import { atlTheme } from '../../atlTheme'
import { ConstructionDocumentListItem } from './ConstructionDocumentListItem'
import { formatMessage } from '../../constants/strings/intl/intlHooks'
import { messages } from '../../constants/strings/messages'
import {
  DownloadFile,
  checkAndroidWriteExternalStoragePermission,
  askAndroidDowloadPermission,
} from '../../utils/downloadFile'
import { DocumentType } from '../../constants/types'
import { Platform } from 'react-native'

interface ConstructionDocumentsListProps {
  documentsUrl: { [key: string]: string }
}

const onPressDownload = (documentUrl: string) => {
  if (Platform.OS === 'android') {
    checkAndroidWriteExternalStoragePermission().then(permissionGranted => {
      if (permissionGranted) {
        DownloadFile(documentUrl)
      } else {
        askAndroidDowloadPermission()
      }
    })
  } else {
    DownloadFile(documentUrl)
  }
}

export const ConstructionDocumentsList: React.FunctionComponent<ConstructionDocumentsListProps> = props => {
  const {
    [DocumentType.BLUE_PRINT]: bluePrintUrl,
    [DocumentType.CUSTOMER_MANUAL]: customerManualUrl,
    [DocumentType.DESCRIPTIVE_MEMORIAL]: descriptiveMemorialUrl,
    [DocumentType.ENTERPRISE_IMPLEMENTATION]: enterpriseImplementationUrl,
  } = props?.documentsUrl
  const atLeastOneDocumentLink = Object.values(props?.documentsUrl || {}).some(url => !!url)

  const onPressBlueprint = () => {
    onPressDownload(bluePrintUrl)
  }
  const onPressCustomerManual = () => {
    onPressDownload(customerManualUrl)
  }
  const onPressDescriptiveMemorial = () => {
    onPressDownload(descriptiveMemorialUrl)
  }
  const onPressEnterpriseImplantation = () => {
    onPressDownload(enterpriseImplementationUrl)
  }

  return (
    <>
      <ATLTextHead
        textAlignment={TextAlignmentEnum.left}
        labelBaseProps={{
          fontSize: atlTheme.FontSizeHeading,
          fontWeight: FontWeightEnum.normal,
        }}
        horizontalMargin={atlTheme.SpacingMarginal}
        verticalMargin={atlTheme.SpacingMarginal}
      >
        {formatMessage(messages.constructions_documents_downloadsTitle)}
      </ATLTextHead>
      {atLeastOneDocumentLink ? (
        <>
          {bluePrintUrl && (
            <>
              <ConstructionDocumentListItem
                text={formatMessage(messages.constructions_documents_blueprintWithMeasures)}
                onPress={onPressBlueprint}
              />
              <ATLDivider dividerBaseProps={{ color: atlTheme.ColorBackground }} />
            </>
          )}
          {customerManualUrl && (
            <>
              <ConstructionDocumentListItem
                text={formatMessage(messages.constructions_documents_clientManual)}
                onPress={onPressCustomerManual}
              />
              <ATLDivider dividerBaseProps={{ color: atlTheme.ColorBackground }} />
            </>
          )}
          {descriptiveMemorialUrl && (
            <>
              <ConstructionDocumentListItem
                text={formatMessage(messages.constructions_documents_memorial)}
                onPress={onPressDescriptiveMemorial}
              />
              <ATLDivider dividerBaseProps={{ color: atlTheme.ColorBackground }} />
            </>
          )}
          {enterpriseImplementationUrl && (
            <ConstructionDocumentListItem
              text={formatMessage(messages.constructions_documents_implantation)}
              onPress={onPressEnterpriseImplantation}
            />
          )}
          <ATLSpacing type={SpacingSizesEnum.marginal} />
        </>
      ) : (
        <>
          <ATLTextBody labelBaseProps={{ multilineLimit: 2 }}>
            {formatMessage(messages.constructions_documents_noDocs)}
          </ATLTextBody>
          <ATLSpacing type={SpacingSizesEnum.base} />
        </>
      )}
    </>
  )
}
